import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { METHOD_STEPS } from "../../data/content";
import { Reveal, Eyebrow } from "../motion";

export const Method = () => {
  const navigate = useNavigate();
  return (
    <section id="methode" className="scroll-mt-20 bg-[#1D1327] py-24 lg:py-36" data-testid="section-methode">
      <div className="mx-auto max-w-[1500px] px-6 sm:px-10 lg:px-16">
        <div className="grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Reveal>
              <Eyebrow>Notre méthode</Eyebrow>
            </Reveal>
            <Reveal delay={0.08}>
              <h2 className="mt-6 font-serif text-4xl leading-[1.08] text-cream sm:text-5xl lg:text-6xl">
                De l'idée à la première réservation.
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 lg:self-end">
            <Reveal delay={0.16}>
              <p className="text-lg leading-relaxed text-white/55">
                Une méthode structurée pour transformer une opportunité immobilière en un concept rentable et
                différenciant.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="mt-20 border-t border-white/10">
          {METHOD_STEPS.map((step, i) => (
            <Reveal key={step.number} delay={Math.min(i * 0.03, 0.2)}>
              <div
                data-testid={`method-step-${step.number}`}
                className="group grid grid-cols-[3.5rem_1fr] items-baseline gap-x-6 gap-y-2 border-b border-white/10 py-7 px-2 transition-colors duration-300 hover:bg-white/[0.03] sm:px-6 lg:grid-cols-[6rem_20rem_1fr]"
              >
                <span className="font-mono text-sm text-neon">{step.number}</span>
                <h3 className="font-serif text-2xl tracking-wide text-cream transition-transform duration-300 group-hover:translate-x-2 sm:text-3xl lg:uppercase">
                  {step.title}
                </h3>
                <p className="col-span-2 text-sm leading-relaxed text-white/50 lg:col-auto lg:text-right lg:text-base">
                  {step.description}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <button
            onClick={() => navigate("/", { state: { scrollTo: "accompagnements" } })}
            data-testid="method-cta-accompagnement"
            className="btn-primary mt-14"
          >
            Découvrir notre accompagnement <ArrowRight className="h-4 w-4" />
          </button>
        </Reveal>
      </div>
    </section>
  );
};
